import { call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessageString } from "utils/utils";
import apiService from "services/apiservice";
import { loadState } from "library/helpers/sessionStorage";
import { ADD_UPDATE_ECOLAB_ITEMDETAILS_REQUEST, FETCH_ECOLAB_ITEMDETAILS_LIST_REQUEST } from "./actionTypes";
import { addUpdateEcolabItemDetailsFailure, addUpdateEcolabItemDetailsSuccess, fetchEcolabItemDetailsListFailure, fetchEcolabItemDetailsListSuccess } from "./actions";
import { EcolabItemDetails } from "./types";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};


function* fetchEcolabItemDetailsListSaga(action: any) {
  try {
    const response: EcolabItemDetails[] = yield call(
      postRequest,
      action.url,
      action.payload
    );

    const totalCount = (response && response.length > 0 && response[0]?.totalCount)
      ? response[0].totalCount
      : 0;
    yield put(fetchEcolabItemDetailsListSuccess(response, totalCount));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(fetchEcolabItemDetailsListFailure(errorMessage));
  }
}

function* addUpdateEcolabItemDetailsSaga(action: any) {
  try {
    const response: { status: string; message: string } = yield call(
      postRequest,
      action.url,
      action.payload
    );
    yield put(addUpdateEcolabItemDetailsSuccess(response.message));
    action.callback("Success", response.message);
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(addUpdateEcolabItemDetailsFailure(errorMessage));
    action.callback("Error", errorMessage);
  }
}

export default function* ecolabItemDetailsSaga() {
   yield takeLatest(FETCH_ECOLAB_ITEMDETAILS_LIST_REQUEST, fetchEcolabItemDetailsListSaga);
  yield takeLatest(ADD_UPDATE_ECOLAB_ITEMDETAILS_REQUEST, addUpdateEcolabItemDetailsSaga);
}